import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import setLotToAvailable from '../Agreement/setLotToAvailable.api';

const firebaseRef = firebase.database();

export default async function deletePurchaser(leadId, salesAgent, lotId) {
	console.log('deletePurchaser lotId', lotId);
	firebaseRef
		.ref(
			'/kavtek_purchasers/' + PROJECT_CODE.projectCode + '/' + salesAgent
		)
		.child(leadId)
		.remove();

	firebaseRef
		.ref('/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId)
		.remove();

	if (lotId) {
		setLotToAvailable(lotId);

		let setLotToAvailableFunc = firebase
			.functions()
			.httpsCallable('setLotToAvailable');
		await setLotToAvailableFunc({
			lotId: lotId,
			projectCode: PROJECT_CODE.projectCode
		});
	}
}
